import * as React from 'react';

export const AdaptiveFormContainerDefProps = {
  containerMode: "twoHalfCardWidthFields",
  fieldsArr: [
    <div style={{width: "100%", backgroundColor: "green", height: "40px"}}></div>,
    <div style={{width: "100%", backgroundColor: "green", height: "40px"}}></div>
  ]
};